import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

export const ImgContainer = styled.div`
  ${({ theme }) => `
    max-height: 50%;
    min-height: 200px;
    width: 100%;
    max-width: 424px;
  `};
`;

export const Title = styled(Typography)`
  ${({ theme }) => `
    color: ${theme.palette.primary.main};
    font-size: 20px;
    margin-top: 30px;
    margin-bottom: 10px;
  `};
`;

export const Description = styled(Typography)`
  ${({ theme }) => `
    color: ${theme.palette.grey[600]};
    marginBottom: ${theme.spacing(2)};
  `};
`;
